export const DEFAULT_POSITION_NAME_MIN_LENGTH = 3;
export const DEFAULT_POSITION_NAME_MAX_LENGTH = 40;
export const DEFAULT_POSITION_DESCRIPTION_MAX_LENGTH = 50000;
export const DEFAULT_IS_HIDDEN_EXPIRED_POSITIONS = false;

export const PAGE_SIZE = 10;
